import React from 'react'
import { observer } from 'mobx-react'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'
import { Spacer } from '../../../../../ui/atoms'
import { CompProps } from '../../Editor'
import { BtPercentageInput } from '@linqpal/components/src/ui/BtPercentageInput'
import ApplicationStore from '../../ApplicationStore'

const OwnerPercentage: React.FC<CompProps> = (props) => {
  const { t } = useTranslation('application')
  const { doc, group, item, onValueUpdate, review } = props

  const validate = (value: string | null) =>
    value ? Number(value) <= ApplicationStore.availableOwnerPercentage() : false

  const model = useEditorModel(doc, group, item, onValueUpdate, '', validate)

  const validatePercentage = (value: string | undefined) => {
    const percentage = Number(value)
    const availablePercent = ApplicationStore.availableOwnerPercentage()

    return percentage > availablePercent
      ? t('ValidationErrors.InvalidMaximumPercentage', {
          maxPercent: availablePercent,
        })
      : ''
  }

  return (
    <>
      <Spacer height={review ? 24 : 18} />
      <BtPercentageInput
        value={model.value}
        onChangeText={(e) => model.setValue('ownershipPercentage', e)}
        validate={validatePercentage}
        label={t('Owner.PercentageLabel')}
        testID="OwnershipPercentage"
      />
    </>
  )
}

export default {
  title: 'Owner.OwnerPercentage',
  component: observer(OwnerPercentage),
}
